export const scrollRef = { lenis: null };

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (scrollRef.lenis) {
    scrollRef.lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
